import Banner from "../components/Banner";
import galeria_anteriores from "../assets/Headers-otrosanos.jpg";

const Anteriores = () => {
  const contenidoBanner = {
    titulo: "Años Anteriores",
    texto:
      "Así hemos festejado el amor durante nueve años, conozcan las historias de nuestras parejas ganadoras y recuerden que ustedes pueden ser los próximos en casarse.",
    imagen: galeria_anteriores,
  };

  return (
    <>
      {/* <div className="containerTelon">
        <div className="telon"></div>
      </div> */}
      <Banner contenidoBanner={contenidoBanner} />
      <div className="global__container container transparentBackground pt-5">
	  	<div className="row text-center">
	  		<div className="col-12">
	  			<iframe className="mb-3" width="100%" height="510" src="https://www.youtube.com/embed/LmNWrv1XmZo" title="Casate con Martha 2019" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen gesture="media"></iframe>
          <h3 className="my-4 text-white">2019</h3>
      </div>
	  	</div>
        <div className="row text-center">
          <div className="col-6">
            <iframe
              title="Casate con Martha 2018"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/y-m3C3mN0iE"
              frameBorder="0"
              gesture="media"
              allow="encrypted-media"
              allowFullScreen
            ></iframe>
            <h3 className="my-4 text-white">2018</h3>
          </div>
          <div className="col-6">
            <iframe
              title="Casate con Martha 2017"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/WoJH5NcJ_rM"
              frameBorder="0"
              gesture="media"
              allow="encrypted-media"
              allowFullScreen
            ></iframe>
            <h3 className="my-4 text-white">2017</h3>
          </div>
        </div>
        <div className="row text-center">
          <div className="col-6">
            <iframe
              title="Casate con Martha 2016"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/2DYkcwFYXBQ"
              frameBorder="0"
              gesture="media"
              allow="encrypted-media"
              allowFullScreen
            ></iframe>
            <h3 className="my-4 text-white">2016</h3>
          </div>
          <div className="col-6">
            <iframe
              title="Casate con Martha 2014"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/CUT6auIAv0A"
              frameBorder="0"
              gesture="media"
              allow="encrypted-media"
              allowFullScreen
            ></iframe>
            <h3 className="my-4 text-white">2014</h3>
          </div>
        </div>
        <div className="row text-center">
          <div className="col-6">
            <iframe
              title="Casate con Martha 2013"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/tMuLe8xeWD0"
              frameBorder="0"
              gesture="media"
              allow="encrypted-media"
              allowFullScreen
            ></iframe>
            <h3 className="my-4 text-white">2013</h3>
          </div>
          <div className="col-6">
            <iframe
              title="Casate con Martha 2012"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/UUNnsS0gjQg"
              frameBorder="0"
              gesture="media"
              allow="encrypted-media"
              allowFullScreen
            ></iframe>
            <h3 className="my-4 text-white">2012</h3>
          </div>
        </div>
      </div>
    </>
  );
};

export default Anteriores;
